import React from 'react';
import '../../App.css';

export default function Services() {
  return (
    <>
      <h1 className='services'>Vision</h1>
      <div className='services-center'>
      <ul className='custom-font custom-color'>
       
          <li className='custom-margin'><b>KNOW YOUR FARMER. KNOW YOUR FOOD.</b></li>
           <li  className='custom-margin'><b>TURN OFF YOUR NETFLIX AND LOOKOUT FOR YOUR FARMER.</b></li>
           <li  className='custom-margin'><b>BUILD DIRECT CHAINS OF CONTACT WITH FARMERS FOR YOUR NUTRITION.</b></li>

        
        {/* <li>
          We make use of natural resources to live close to nature.</li> <li>Our farm is equipped with solar panels for energy consumption</li>
        <li>We have installed solar powered camera to monitor our field</li>
        <li>we also make use of bio enzyme for cleaning purposes</li>
        <li>We perform Agnihotra to purify the environment</li>

        <li>We also grow organic vegetables</li>
        <li>We are growing desi varieties of wheat: Sona moti and Bansi</li>
        <li>Sona Moti and Bansi wheat is a popular wheat variety in India. We bought seeds from Gurukul Kurukshetra. </li> */}

      </ul>
      </div>
      {/* <div className='blog-flex-container custom-font'><p className='custom-text'><b>Some of the special characteristics and features of Sona Moti wheat are:</b></p>

        <p className='custom-text'><b>High Yield:</b> Sona Moti wheat is known for its high yield potential, which means that it can produce more grains per unit area compared to other varieties of wheat.
        </p>
        <p className='custom-text'><b>Good Quality:</b> Sona Moti wheat has good quality grain with high protein content, good gluten strength, and desirable baking properties.
        </p>
        <p className='custom-text'><b>Drought Tolerance: </b>Sona Moti wheat is known for its tolerance to drought conditions, making it suitable for cultivation in areas with low rainfall.
        </p>
        <p className='custom-text'><b>Disease Resistance:</b> Sona Moti wheat has some resistance to common diseases such as rust, smut, and blight, reducing the need for chemical inputs.
        </p>
        <p className='custom-text'><b>Adaptability:</b> Sona Moti wheat is adaptable to a wide range of agro-climatic conditions, making it suitable for cultivation in different regions of India.
        </p>
        <p className='custom-text'>Overall, Sona Moti wheat is a high-yielding, good-quality variety of wheat that is well-suited to the growing conditions in India.
        </p></div>

      <div className='blog-flex-container custom-font'>
        <p className='custom-text'><b>
          Bansi wheat is a popular variety of wheat that is grown in India. Here are some of the special characteristics and features of Bansi wheat:</b></p>

        <p className='custom-text'><b>High Yield:</b> Bansi wheat is known for its high yield potential, which means that it can produce more grains per unit area compared to other varieties of wheat.
        </p>
        <p className='custom-text'><b>Good Quality:</b>
          Bansi wheat has good quality grain with high protein content, good gluten strength, and desirable baking properties.
        </p>
        <p className='custom-text'><b>Early Maturity: </b>
          Bansi wheat matures early, which means that it requires less time to reach maturity compared to other wheat varieties.
        </p>
        <p className='custom-text'><b>Disease Resistance:</b>
          Like Sona Moti wheat, Bansi wheat also has some resistance to common diseases such as rust and leaf blight, reducing the need for chemical inputs.
        </p>
        <p className='custom-text'><b>Adaptability:</b>
          Bansi wheat is adaptable to a wide range of agro-climatic conditions, making it suitable for cultivation in different regions of India.
        </p>
        <p className='custom-text'>Overall, Bansi wheat is a high-yielding, good-quality variety of wheat that is well-suited to the growing conditions in India. It is particularly popular in the states of Uttar Pradesh and Bihar due to its early maturity and adaptability to different soil and climatic conditions.
        </p></div>
 */}



    </>
  );
}
